// extracted by mini-css-extract-plugin
module.exports = {"form":"InputForm_form__NsYLb","input":"InputForm_input__hbiWp","sendButton":"InputForm_sendButton__1bi4m"};